import React from 'react';
import PropTypes from 'prop-types';
import { compose, wrapDisplayName } from 'recompose';
import { withFetch, withLoading } from 'modules/with-fetch';
import { startCase, orderBy } from 'lodash';
import moment from 'moment';

import { withRouter } from 'react-router-dom';

import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';

import { populateMergeTags, smartFilter } from 'modules/functions';
import {
  messageTemplateTypesArray,
  stringForMessageTemplateTypes,
} from 'modules/enums/message-template-types';

class MessageTemplatePicker extends React.Component {
  static propTypes = {
    templatePickerOpen: PropTypes.bool,
    messageTemplatesList: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    myClient: PropTypes.object.isRequired,
    myTrainer: PropTypes.object.isRequired,
    fullChatRoom: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    trainerId: PropTypes.any.isRequired,
  };

  static defaultProps = {
    templatePickerOpen: false,
  };

  state = {
    popoverOpen: this.props.templatePickerOpen,
    selectedType: null,
    filterOwnership: -1,
    filterString: '',
  };

  onFilterChange = (e) => {
    this.setState({
      filterString: e.target.value,
    });
  };

  toggle = () => {
    this.setState((prevState) => ({
      popoverOpen: !prevState.popoverOpen,
    }));
  };

  handleTemplateSelect = (selectedTemplate) => {
    const messageBody = populateMergeTags(
      selectedTemplate.message,
      this.props.myClient.data[0],
      this.props.myTrainer.data[0],
    );
    this.props.setFieldValue('templateId', selectedTemplate.id);
    this.props.setFieldValue(
      'globalOriginTemplateId',
      selectedTemplate.globalOriginTemplateId,
    );
    this.props.setFieldValue('text', messageBody);

    this.setState({
      popoverOpen: false,
    });
  };

  changeType = (e) => {
    const newType = e.target.value;
    this.setState({
      selectedType: newType,
    });
  };

  handleOwnershipFilterChange = (event) => {
    const { value } = event.target;
    this.setState({ filterOwnership: Number.parseInt(value, 10) });
  };

  renderTypeFilter = () => (
    <div className="form-group ">
      <label htmlFor="inputState">Filter by template types:</label>
      <select
        id="inputState"
        className="form-control"
        value={this.state.selectedType}
        onChange={this.changeType}
      >
        {/* <option value="0">All</option> */}
        {/* TODO: Swap these to a function that outputs the options based on the list object below */}
        <option key={-5} value={-1}>
          Select a type to filter...
        </option>
        {messageTemplateTypesArray.map((entry) => (
          <option key={entry} value={entry}>
            {startCase(stringForMessageTemplateTypes[entry])}
          </option>
        ))}
      </select>
    </div>
  );

  renderPhraseFilter = () => (
    <div className="form-group">
      <label htmlFor="category">Filter Templates by Phrase: </label>
      <input
        type="text"
        className="form-control"
        onChange={this.onFilterChange}
      />
    </div>
  );

  renderOwnershipFilter = () => (
    <div className="form-group row mb-0">
      <label htmlFor="filterTemplates" className="col-sm-4 col-form-label">
        Filter By Ownership:
      </label>
      <div className="col-sm-8 text-right" id="filterTemplates">
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            id="filterAll"
            checked={this.state.filterOwnership === -1}
            onChange={this.handleOwnershipFilterChange}
            value={-1}
          />
          <label className="form-check-label" htmlFor="filterAll">
            All
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            id="filterGlobal"
            checked={this.state.filterOwnership === 0}
            onChange={this.handleOwnershipFilterChange}
            value={0}
          />
          <label className="form-check-label" htmlFor="filterGlobal">
            Global
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="radio"
            id="filterMine"
            checked={this.state.filterOwnership === this.props.trainerId}
            onChange={this.handleOwnershipFilterChange}
            value={this.props.trainerId}
          />
          <label className="form-check-label" htmlFor="filterMine">
            Mine
          </label>
        </div>
      </div>
    </div>
  );

  renderMessageTemplateOptions = () => {
    const filteredTemplates = this.props.messageTemplatesList.data;

    let withLastSent = filteredTemplates;
    if (
      this.props.fullChatRoom &&
      this.props.fullChatRoom.data &&
      this.props.fullChatRoom.data.length > 0
    ) {
      const { messages } = this.props.fullChatRoom.data[0];
      withLastSent = filteredTemplates.map((template) => {
        const newTemplate = Object.assign({}, template);
        newTemplate.lastTemplateSend = null;
        messages.forEach((message) => {
          if (!message.templateId) {
            return;
          }
          // Right here - we are going through all the templates. We need to check against both this template IDs OR if this message's template ID matches any global origin ID
          if (
            message.templateId === template.id ||
            (template.globalOriginId &&
              message.globalOriginTemplateId === template.globalOriginId)
          ) {
            newTemplate.lastTemplateSend = message.sent;
          }
        });

        return newTemplate;
      });

      if (this.state.selectedType && this.state.selectedType !== -1) {
        withLastSent = withLastSent.filter(
          (template) => template.category == this.state.selectedType,
        );
      }

      if (this.state.filterOwnership !== -1) {
        withLastSent = withLastSent.filter(
          (template) => template.trainerId == this.state.filterOwnership,
        );
      }

      if (this.state.filterString) {
        withLastSent = withLastSent.filter(
          (template) =>
            template.title &&
            smartFilter(template.title, this.state.filterString),
        );
      }
    }

    withLastSent = orderBy(
      withLastSent,
      ['lastTemplateSend', 'title'],
      ['desc', 'asc'],
    );
    // Label/disable templates that have been used in the past three months

    return withLastSent.map((messageTemplate) => {
      let label = messageTemplate.title;
      let disabled = false;
      label = messageTemplate.trainerId === 0 ? `[G] ${label}` : label;
      if (moment(messageTemplate.lastTemplateSend).isValid()) {
        const lastSentMoment = moment(messageTemplate.lastTemplateSend).format(
          'ddd, MMM Do',
        );

        // Label last sent
        label = `(Sent: ${lastSentMoment}) ${messageTemplate.title} `;
        label = messageTemplate.trainerId === 0 ? `[G] ${label}` : label;
        disabled = moment(messageTemplate.lastTemplateSend).isAfter(
          moment().subtract(3, 'months'),
        );
      }
      return (
        <button
          disabled={disabled}
          key={messageTemplate.id}
          className="btn btn-outline-primary btn-block message-template-button"
          type="button"
          title={messageTemplate.message}
          data-toggle="tooltip"
          data-placement="top"
          onClick={() => this.handleTemplateSelect(messageTemplate)}
        >
          {label}
        </button>
      );
    });
  };

  render() {
    // console.devLog.info('chat text box props match:', this.props);
    // console.devLog.info('Message template picker state:', this.state);
    const positionClass =
      this.props.match.path === '/clients'
        ? 'template-popover-left'
        : 'template-popover-right';
    return (
      <React.Fragment>
        <button
          type="button"
          onClick={this.toggle}
          className={`btn chat-textbox-select ml-2 ${
            this.state.popoverOpen ? 'active' : ''
          }`}
          data-display="static"
          id="popover-template-picker"
        >
          Templates
        </button>
        <Popover
          placement="top"
          isOpen={this.state.popoverOpen}
          target="popover-template-picker"
          // toggle={this.toggle}
          trigger="legacy"
          className={`message-template-popover ${positionClass} `}
        >
          <PopoverBody>
            <PopoverHeader>
              <h4>Select Message Template</h4>
            </PopoverHeader>
            {this.renderOwnershipFilter()}
            {this.renderTypeFilter()}
            {this.renderPhraseFilter()}
            {this.renderMessageTemplateOptions()}
          </PopoverBody>
        </Popover>
      </React.Fragment>
    );
  }
}

/* eslint-disable react/no-multi-comp */
const EnhancedComponent = class PropHOCWrapper extends React.Component {
  static propTypes = {
    trainerId: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);
    this.createWrappedComp();
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.clientId !== this.props.clientId) {
  //     this.createWrappedComp();
  //   }
  // }

  createWrappedComp = () => {
    this.Comp = compose(
      withRouter,
      withFetch(
        'Trainer/MyMessageTemplates',
        { query: { trainerId: this.props.trainerId } },
        'messageTemplatesList',
      ),
      withLoading('messageTemplatesList'),
    )(MessageTemplatePicker);
  };

  render() {
    return <this.Comp {...this.props} />;
  }
};

EnhancedComponent.displayName = wrapDisplayName(
  MessageTemplatePicker,
  'withFetch',
);

export default EnhancedComponent;
